import { motion } from 'framer-motion';
import { Users, Sparkles, Star, Image, Brain, Layers } from 'lucide-react';

export function CommunitySection() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-primary/20 via-primary/10 to-primary/5">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -left-1/4 top-0 h-32 w-32 rounded-full bg-primary/20 blur-3xl" />
        <div className="absolute -right-1/4 bottom-0 h-32 w-32 rounded-full bg-primary/20 blur-3xl" />
        <div className="absolute left-1/2 top-1/2 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/10 blur-3xl" />
      </div>

      <div className="relative py-12 px-4 sm:px-8">
        <div className="mx-auto max-w-5xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-8 flex items-center gap-3"
          >
            <Users className="h-6 w-6 text-primary" />
            <h2 className="text-3xl font-light text-foreground">
              Our community
            </h2>
          </motion.div>

          <div className="space-y-6">
            <motion.h3
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="m-0"
            >
              <div className="flex items-center gap-3 text-2xl font-bold text-foreground">
                <Sparkles className="h-5 w-5 text-primary" />
                We are powered by a world-class community of creative
                professionals.
              </div>
            </motion.h3>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="flex items-center gap-3 text-lg font-light text-foreground"
            >
              <Star className="h-5 w-5 text-primary" />
              Our AI models are trained on diverse datasets, giving you access
              to a large collection of unique and high-quality content.
            </motion.div>

            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3"
            >
              <div className="bg-card/50 border-border/50 rounded-xl border p-4 backdrop-blur-sm">
                <div className="flex items-center gap-3">
                  <Users className="h-5 w-5 text-primary" />
                  <div>
                    <div className="text-2xl font-bold text-primary">10K+</div>
                    <div className="text-muted-foreground text-sm">
                      Active Users
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-card/50 border-border/50 rounded-xl border p-4 backdrop-blur-sm">
                <div className="flex items-center gap-3">
                  <Image className="h-5 w-5 text-primary" />
                  <div>
                    <div className="text-2xl font-bold text-primary">1M+</div>
                    <div className="text-muted-foreground text-sm">
                      Images Generated
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-card/50 border-border/50 rounded-xl border p-4 backdrop-blur-sm">
                <div className="flex items-center gap-3">
                  <Brain className="h-5 w-5 text-primary" />
                  <div>
                    <div className="text-2xl font-bold text-primary">500+</div>
                    <div className="text-muted-foreground text-sm">
                      Custom Models
                    </div>
                  </div>
                </div>
              </div>
            </motion.div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
